export default function About() {
  return (
    <section id="about" className="py-12 md:py-16 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12">
          <div className="flex-1 order-2 lg:order-1">
            <h2 className="text-xl md:text-2xl font-black text-foreground-950 mb-4">关于酷看漫画</h2>
            <div className="text-sm md:text-base text-foreground-600 leading-relaxed space-y-3">
              <p>
                酷看漫画成立于2020年，是一个专注于<strong>韩漫、日漫、国漫</strong>分类整理的在线阅读平台。
                我们致力于为漫画爱好者提供最便捷的漫画发现和阅读体验，让找好看的漫画变得一搜即达。
              </p>
              <p>
                平台收录超过<strong>2000部</strong>优质漫画作品，涵盖玄幻、恋爱、热血、悬疑、搞笑、奇幻、校园等十余种类型标签。
                我们的编辑团队每日追踪全网漫画更新动态，为你精选推荐当下最值得一读的作品。
              </p>
              <p>
                无论你是韩漫忠实粉丝、日漫经典爱好者，还是国漫崛起见证者，酷看漫画都欢迎你的加入。
                我们相信，好的漫画值得被更多人看到。
              </p>
            </div>
            <div className="flex flex-wrap items-center gap-6 mt-6">
              <div className="text-center">
                <span className="block text-2xl md:text-3xl font-black text-primary-500">2000+</span>
                <span className="text-xs text-foreground-400">漫画收录</span>
              </div>
              <div className="text-center">
                <span className="block text-2xl md:text-3xl font-black text-accent-500">10+</span>
                <span className="text-xs text-foreground-400">类型分类</span>
              </div>
              <div className="text-center">
                <span className="block text-2xl md:text-3xl font-black text-primary-500">每日</span>
                <span className="text-xs text-foreground-400">更新推荐</span>
              </div>
            </div>
          </div>

          <div className="flex-1 order-1 lg:order-2 w-full max-w-[400px]">
            <div className="relative aspect-square rounded-2xl overflow-hidden bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Cozy%20reading%20nook%20with%20manga%20books%20and%20tablet%20displaying%20colorful%20comic%20pages%2C%20warm%20ambient%20lighting%20from%20desk%20lamp%2C%20comfortable%20chair%2C%20shelves%20filled%20with%20manga%20volumes%2C%20warm%20coral%20and%20cream%20color%20scheme%2C%20inviting%20atmosphere%2C%20illustration%20style%20with%20clean%20lines%20and%20soft%20shading&width=800&height=800&seq=manga-about-illustration&orientation=squarish"
                alt="酷看漫画品牌形象 - 温馨阅读场景"
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}